module.exports = __webpack_public_path__ + "img/20190523195717微信截图_20190523200051.6ff96ea9.png";